<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<div class="w-full min-w-0 max-w-full min-h-screen [container-type:inline-size]">
  <div>
    <div class="flex flex-wrap justify-between items-center gap-x-8 gap-y-4 mb-8 min-w-0">
      <div class="flex shrink-0 items-center">
        <h2 class="whitespace-nowrap text-[16px] font-semibold text-[#000000] dark:text-textDark">
          All ({{
          totalItems === 0
          ? "0"
          : totalItems < 10 ? "0" + totalItems : totalItems }}) </h2>
      </div>

      <div class="grid ml-auto flex-[0_1_36rem] grid-cols-[auto_auto_minmax(13rem,1fr)_minmax(0,2fr)] items-center gap-3 min-w-0 [@container(max-width:760px)]:basis-full [@container(max-width:760px)]:grid-cols-[auto_minmax(0,1fr)]">

        <i class="fa-solid text-[#4A4A4A] fa-list text-lg dark:text-white"></i>

        <p class="text-[#4A4A4A] dark:text-white whitespace-nowrap">Filter By</p>


        <div class="relative z-10 min-w-0 [@container(max-width:760px)]:col-span-full">
          <app-custom-datepicker class="block w-full [&_i]:shrink-0" placeholderClass="italic truncate min-w-0" [placeholder]="'Dispatched Date'" [selectedDate]="dateFilter"
            (dateChange)="onDateChange($event)"></app-custom-datepicker>
        </div>

        <div class="flex items-center rounded-full px-4 py-2 min-w-0 [&_button]:shrink-0 bg-[#F1F1F1] dark:bg-[#292929] [@container(max-width:760px)]:col-span-full">
          <input type="text" placeholder=" Search by Invoice No.." [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
            (keyup.esc)="offSearch()" class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
          <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2" (click)="onSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
            </svg>
          </button>
          <button *ngIf="searchTerm" type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
            (click)="offSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

      </div>


    </div>
    <div class=" w-full min-w-0 max-w-full mt-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021] overflow-x-auto">
      <table *ngIf="hasData" class="w-full min-w-max divide-y-2">
        <thead class="text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
          <tr>
            <th class="px-4 py-3 font-normal text-[#4B5563] dark:text-textDark text-left">
              No
            </th>
            <th class="px-4 py-3 font-normal text-[#4B5563] dark:text-textDark text-left">
              Invoice No
            </th>
            <th class="px-4 py-3 font-normal text-[#4B5563] dark:text-textDark text-left">
              Application
            </th>
            <th class="px-4 py-3 font-normal text-[#4B5563] dark:text-textDark text-left">
              Total Price of Products (Rs.)
            </th>
            <th class="px-2 py-3 font-normal text-[#4B5563] dark:text-textDark text-left">
              Sent By
            </th>
            <th class="px-4 py-3 font-normal text-[#4B5563] dark:text-textDark text-center">
              Sent To Dispatch
            </th>

          </tr>
        </thead>
        <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
          <tr (click)="viewPremadePackages(order.processOrderId)" *ngFor="
                let order of orders
                  | paginate
                    : {
                        itemsPerPage: itemsPerPage,
                        currentPage: page,
                        totalItems: totalItems
                      };
                let i = index
              " class="hover:bg-[#415CFF] text-textLight dark:text-textDark hover:text-[#FFFFFF]  cursor-pointer">
            <td class="px-4 py-3 text-left text-[#000000] dark:text-textDark">
              {{ (page - 1) * itemsPerPage + i + 1 }}
            </td>
            <td class="px-4 py-3 text-left text-[#000000] dark:text-textDark">
              {{ order.invNo || "N/A" }}
            </td>
            <td class="px-4 py-3 text-left text-textLight dark:text-textDark">
              {{
              order.orderApp === "Dash"
              ? "SalesDash"
              : order.orderApp === "Marketplace"
              ? "Polygon"
              : order.orderApp
              }}
            </td>
            <td class="px-4 py-3 text-left text-[#000000] dark:text-textDark">
              {{ order.total | number : "1.2-2" }}
            </td>
            <td class="px-2 py-3 text-left text-[#000000] dark:text-textDark">
              {{ order.dispatchedBy === null ? '--': order.dispatchedBy }}
            </td>
            <td class="px-4 py-3 text-center text-[#000000] dark:text-textDark">
              <p>{{ getDatePart(order.processCreatedAt)}}</p>
              <p>{{ getTimePart(order.processCreatedAt)}}</p>
            </td>

          </tr>
        </tbody>
      </table>

      
    </div>
    
    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6">
        <p class="text-[#494949] my-6 dark:text-textDark">
          --No Data Available--
        </p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
      </div>
      
    <div *ngIf="hasData" class="flex justify-end items-center my-5 mr-5 pt-3 dark:bg-[#1D1D1F] text-right">
      <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
        [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
        [screenReaderCurrentLabel]="'Youre on page'">
      </pagination-controls>
    </div>

  </div>
</div>